export const STATE = {
    VERIFICATION: 'b3154142396911ed867dfa163e89e3c8',
    ASSIGN_TASK: 'c726800f396911ed867dfa163e89e3c8',
    COMPLETE_TASK: 'd02c3c95396911ed867dfa163e89e3c8',
    OTHER_TASK: 'k5tc3c95396911ed867dfa163e89e123',
    CANCEL_TASK: 'k5tc3c95396911ed867dfa163e89e333',
};
